import { Box } from '@mui/material';
import { ResponsiveBar } from '@nivo/bar';
import ChartSection from '../shared/ChartSection';
import ChartTooltip from '../shared/ChartTooltip';
import useNivoTheme from '../shared/useNivoTheme';

export default function ExperienceVsAlpha({ data }) {
    const { theme, colors } = useNivoTheme();
    if (!data?.summary || data.summary.length === 0) return null;

    const chartData = data.summary.map(s => ({
        experience: s.experience,
        members: s.members,
        'Avg Alpha': s.avg_alpha,
    }));

    const values = chartData.map(d => d['Avg Alpha']);
    const minV = Math.min(0, ...values);
    const maxV = Math.max(0, ...values);
    const pad = Math.max(1, (maxV - minV) * 0.1);

    return (
        <ChartSection
            id="experience"
            title="Do they get better at trading over time?"
            subtitle="Average alpha by years in office"
        >
            <Box sx={{ height: 320 }}>
                <ResponsiveBar
                    data={chartData}
                    keys={['Avg Alpha']}
                    indexBy="experience"
                    margin={{ top: 20, right: 20, bottom: 70, left: 55 }}
                    padding={0.4}
                    borderRadius={3}
                    minValue={minV - pad}
                    maxValue={maxV + pad}
                    colors={({ data: d }) => (d['Avg Alpha'] >= 0 ? colors.success : colors.error)}
                    enableLabel
                    label={d => (d.value > 0 ? '+' : '') + d.value.toFixed(1) + '%'}
                    labelSkipHeight={8}
                    labelTextColor="#ffffff"
                    axisBottom={{
                        format: v => {
                            const row = chartData.find(r => r.experience === v);
                            return row ? `${row.experience} (${row.members})` : v;
                        },
                        tickRotation: 0,
                        legend: 'Years in office (member count)',
                        legendPosition: 'middle',
                        legendOffset: 50,
                    }}
                    axisLeft={{
                        format: v => v + '%',
                        legend: 'Alpha vs S&P 500',
                        legendPosition: 'middle',
                        legendOffset: -45,
                    }}
                    markers={[
                        {
                            axis: 'y',
                            value: 0,
                            lineStyle: { stroke: colors.muted, strokeWidth: 1 },
                        },
                    ]}
                    tooltip={({ data: d }) => (
                        <ChartTooltip
                            title={d.experience}
                            rows={[
                                {
                                    label: 'Avg Alpha',
                                    value:
                                        (d['Avg Alpha'] > 0 ? '+' : '') +
                                        d['Avg Alpha'].toFixed(2) +
                                        '%',
                                    valueColor: d['Avg Alpha'] >= 0 ? 'success.main' : 'error.main',
                                },
                                { label: 'Members', value: d.members },
                            ]}
                        />
                    )}
                    theme={theme}
                />
            </Box>
        </ChartSection>
    );
}
